export const buildIncludeQuery = <T extends string>(includes?: T[]) => {
  if (!includes?.length) return '';

  const params = new URLSearchParams();

  includes.forEach((include) => {
    params.append('include', include);
  });

  return `?${params.toString()}`;
};

export const addQuery = (query: string, key: string, value: string) => {
  if (!key || !value) return query;
  else return `${query}${query === '' ? '?' : '&'}${key}=${value}`;
};
